import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-termsand-conditions',
  templateUrl: './termsand-conditions.component.html',
  styleUrls: ['./termsand-conditions.component.css']
})
export class TermsandConditionsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
